import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { getRuntimeConfigValue } from './runtimeConfig'

const loadAdobeTagScript = () => {
  const adobeTagUrl = getRuntimeConfigValue('REACT_APP_ADOBE_TAG_URL', process.env.REACT_APP_ADOBE_TAG_URL)

  if (!adobeTagUrl) {
    return
  }

  const adobeScript = document.createElement('script')
  adobeScript.src = adobeTagUrl
  adobeScript.defer = true
  document.head.appendChild(adobeScript)
}

loadAdobeTagScript()

const rootNode = document.getElementById('root')

if (!rootNode) {
  throw new Error('Root element not found')
}

const root = createRoot(rootNode)

root.render(
  <App />
)
